import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import {
  IFundOrderTableReport,
  IFundOrderTableSearchParams,
} from "src/Interfaces/manualInterfaces";
import { getManualFundOrderTable } from "src/Requests/manualRequests";

interface IProps {
  searchParam: IFundOrderTableSearchParams;
}

const ManualFundOrderTable = ({ searchParam }: IProps) => (
  <TableTemplate<IFundOrderTableSearchParams, IFundOrderTableReport>
    refreshTableTime={5000}
    getDataTable={getManualFundOrderTable}
    withSort
    TableUI={({ reports, onAction, sortingType, setSortingType }) => (
      <CommonTableUI
        reports={reports}
        onAction={onAction}
        sortingType={sortingType}
        setSortingType={setSortingType}
        tableBoxClassName="max-h-[500px]"
      />
    )}
    searchParameters={searchParam}
    showPageSize
  />
);

export default ManualFundOrderTable;
